import type { ComponentProps } from "react";

type SvgProps = ComponentProps<"svg">;

const EventSprechstunde = (props: SvgProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_sprechstunde)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.833333 5.33333C0.833333 2.84805 2.84805 0.833333 5.33333 0.833333H10.6667C13.1519 0.833333 15.1667 2.84805 15.1667 5.33333V10.6667C15.1667 13.1519 13.1519 15.1667 10.6667 15.1667H5.33333C2.84805 15.1667 0.833333 13.1519 0.833333 10.6667V5.33333ZM3.5 7.33333C3.5 6.32081 4.32081 5.5 5.33333 5.5H7.33333C8.29153 5.5 9.07793 6.23502 9.15967 7.17193L11.0599 5.74672C11.6533 5.30178 12.4999 5.72508 12.4999 6.46674V9.5334C12.4999 10.2749 11.6533 10.6985 11.0599 10.2534L9.15967 8.8282C9.07787 9.76507 8.29147 10.5 7.33333 10.5H5.33333C4.32081 10.5 3.5 9.6792 3.5 8.66667V7.33333Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_sprechstunde">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default EventSprechstunde;
